<template>
    <div v-bind:class="listClass">
        <v-container fluid>
            <v-row dense class="drag-element-list">
                <template v-for="(element, key) in elements">
                    <listElement v-if="useLegacyElements || element.legacy===false"
                                 :element="element"
                                 :view-privilege="true"
                                 :edit-privilege="false"
                                 :delete-privilege="false"
                                 :small="true"
                                 mode="tiles"
                                 :key="key"
                                 :element-class="elementClass"
                                 :drag-drop="true">
                    </listElement>
                </template>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import listElement from "./elementElementTile.vue";
    import {staticElements} from "../publish/publishUtils";

    export default {
        props: [
            'classes',
            'elementClass',
            'useLegacyElements'
        ],
        components: {
            listElement,
        },
        computed: {
            listClass: function () {
                return this.classes + ' col-md-12';
            },
        },
        data: function () {
            return {
                t_new: Lang.langGet("New"),
                t_validity: Lang.langGet("Validity"),
                t_added: Lang.langGet("Added"),
                t_modified: Lang.langGet("Modified"),
                elements: staticElements
            }
        },
    }
</script>
